<template>
    <collapsible-card :title="'Latest Position'" v-show="posInfo.length > 0" ref="cCard">
        <div class="latestPosLayout">
            <div class="cardContent">
                <div class="category">
                    <div v-for="obj in posInfo" :key="obj.field" class="dataItem">
                        <p v-if="obj.val">{{obj.field}}: <span class="dataEmphasis">{{obj.val}}</span></p>
                        <p v-else><span class="dataEmphasis">{{obj.field}}</span></p>
                    </div>
                    <a class="singleRowFlex downloadLink" :href="'/api/download/vessels/pastWeek/' + mmsi" download><img class="icon" :src="require('@/assets/icons/download.svg')" alt="download"><p class="link">Download Vessel Positions for the Past Week</p></a>
                </div>
                <div class="category" v-if="weatherInfo.length > 0">
                    <h3 class="categoryTitle">Weather</h3>
                    <div v-for="obj in weatherInfo" :key="obj.field" class="dataItem">
                        <p v-if="obj.val">{{obj.field}}: <span class="dataEmphasis">{{obj.val}}</span></p>
                        <p v-else><span class="dataEmphasis">{{obj.field}}</span></p>
                    </div>
                </div>
                <router-link :to="{name: 'WeatherMMSI', params: {mmsi: mmsi}}" target="_blank" class="link">Advanced Weather Data</router-link>
            </div>
            <div class="mapContainer">
                <router-link :to="{name: 'content'}" class="showMapBtn">Show on Live Map</router-link>
                <canvas id="staticMap" class="map"></canvas>
            </div>
        </div>
    </collapsible-card>
</template>

<script>
import {readFromObj, formatDateLT} from '../../helpers/Formatting.js';
import axios from 'axios';
import CollapsibleCard from '../CollapsibleCard.vue';

export default {
    name: "vessel-latest-pos",
    components: {
        CollapsibleCard
    },
    data: () => ({
        posInfo: [],
        weatherInfo: [],
        vesselName: null,
        mmsi: null,
        isCollapsed: false
    }), 
    mounted() {
        var globv = this;
        globv.mmsi = globv.$route.params.mmsi;
    },
    methods: {
        toggleCollapsed: function(shouldCollapse) {
            var globv = this;
            globv.isCollapsed = shouldCollapse;
        },
        passInName: function (name) {
            var globv = this;
            globv.vesselName = name;
        },
        updateInfo: function(latestPosObj) {
            var globv = this;
            globv.posInfo = [];

            if (latestPosObj['time']) {
                let formattedDate = formatDateLT(latestPosObj['time']);
                globv.posInfo.push({
                    field: "Time",
                    val: formattedDate
                })
            }

            if (latestPosObj['coordinates'] && latestPosObj['coordinates'].length == 2) {
                let lat = latestPosObj['coordinates'][1];
                let lon = latestPosObj['coordinates'][0];
                globv.posInfo.push({
                    field: "Latitude / Longitude",
                    val: lat + "° / " + lon + "°"
                })
                globv.createStaticMap(lat, lon, latestPosObj['heading']);
                globv.retrieveWeatherData(lat, lon);
            }

            let expectedVariables = [
                {
                    varName: "status",
                    fieldName: "Status"
                },
                {
                    varName: "speed",
                    fieldName: "Speed",
                    unit: " kn"
                },
                {
                    varName: "course",
                    fieldName: "Course",
                    unit: "°"
                },
                {
                    varName: "heading",
                    fieldName: "Heading",
                    unit: "°"
                },
                {
                    varName: "rateOfTurn",
                    fieldName: "Rate of Turn",
                    unit: "°/min"
                },
                {
                    varName: "draught",
                    fieldName: "Draught",
                    unit: " m"
                },
                {
                    varName: "maneuver",
                    fieldName: "Maneuver"
                },
            ]

            globv.posInfo = globv.posInfo.concat(readFromObj(latestPosObj, expectedVariables));

            if (latestPosObj['weather']) {
                expectedVariables = [
                    {
                        varName: "windSpeed",
                        fieldName: "Wind Speed",
                        format: globv.truncate2Dec,
                        unit: " m/s"
                    },
                    {
                        varName: "windDirection",
                        fieldName: "Wind Direction",
                        format: globv.degreesToCompass
                    },
                    {
                        varName: "airTemp",
                        fieldName: "Air Temperature",
                        format: globv.truncate2Dec,
                        unit: "°C"
                    }
                ]

                globv.weatherInfo = readFromObj(latestPosObj['weather'], expectedVariables);
                globv.$refs.cCard.adjustHeight();
            }
        },
        retrieveWeatherData: async function(lat, lon) {
            var globv = this;
            if (window.sessionStorage.getItem('weather' + globv.mmsi)) {
                if (Date.now() - JSON.stringify(window.sessionStorage.getItem('weather' + globv.mmsi))['created'] > 3600000)
                    window.sessionStorage.removeItem('weather' + globv.mmsi);
                else
                    return;
            }

            try {
                let response = await axios.get('/api/weather', {
                    params: {
                        lat: lat,
                        lon: lon
                    }
                });

                if (response.status < 300 && response['data']) {
                    let weatherData = response['data'];
                    if (globv.vesselName) {
                        weatherData['name'] = globv.vesselName
                    }

                    try {
                        window.sessionStorage.setItem('weather' + globv.mmsi, JSON.stringify({
                            weatherData: weatherData,
                            created: Date.now()
                        }));
                    } catch(e) { console.log(e); }
                }
            }
            catch (error) {
                console.log(error);
            }
        },
        createStaticMap: async function(lat, lon, heading) {
            var globv = this;
            globv.canvasPlaceholder(lat, lon, heading);
            try {
                 let response = await axios.get('/api/vessels/map/pastWeek/' + globv.mmsi, {
                    params: {
                        coordinate: JSON.stringify([lon, lat]),
                        heading: heading
                    }
                });

                if (response && response.data && response.data['map']['link']) {
                    let canvas = document.getElementById('staticMap');
                    let ctx = canvas.getContext('2d');
                    let mapImage = new Image();
                    mapImage.onload = function() {
                        canvas.width = mapImage.width;
                        canvas.height = mapImage.height;
                        ctx.drawImage(mapImage, 0, 0);
                    }

                    mapImage.src = response.data['map']['link'];
                }
            }
            catch (error) {
                console.log(error.response);
            }
        },
        canvasPlaceholder: function(lat, lon, heading) {
            let width = 500;
            let height = 400;
            let staticMapUrl = `https://services.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/export?bbox=${lon - 0.2},${lat - 0.2},${lon + 0.2},${lat + 0.2}&bboxSR=4326&size=${width},${height}&f=image`;
            let canvas = document.getElementById('staticMap');
            let ctx = canvas.getContext('2d');

            let marker = new Image();
            marker.onload = function() {
                if (heading == null) {
                    heading = 0;
                }

                let x = canvas.width / 2;
                let y = canvas.height / 2;
                let width = marker.width / 4;
                let height = marker.height / 4;
                let rotation = (heading / 360) * 2 * Math.PI;

                ctx.translate(x, y);
                ctx.rotate(rotation);
                ctx.drawImage(marker, -width / 2, -height / 2, width, height);
                ctx.rotate(-rotation);
                ctx.translate(-x, -y);
            }

            let mapImage = new Image();
            mapImage.onload = function() {
                canvas.width = mapImage.width;
                canvas.height = mapImage.height;
                ctx.drawImage(mapImage, 0, 0);

                marker.src = "https://www.raptor1.io/images/Gray.png";
            }

            mapImage.src = staticMapUrl;
        },
        degreesToCompass: function(degrees) {
            var globv = this;
            const normalizeDeg = degrees % 360;
            const compassDirection = ["N", "NE", "E", "SE", "S", "SW", "W", "NW", "N"];

            let index = Math.floor(normalizeDeg/45);
            index = normalizeDeg % 45 > 22.5 ? index + 1 : index;

            return compassDirection[index] + " (" + globv.truncate2Dec(degrees) + "°)";
        },
        truncate2Dec: function(num) {
            return num.toFixed(2);
        },
        reset: function() {
            var globv = this;
            globv.posInfo = [];
            globv.weatherInfo = [];
            globv.vesselName = null;
            globv.mmsi = globv.$route.params.mmsi;
            globv.mapSource = "";
        }
    }
}
</script>

<style lang="scss">
.latestPosLayout {
    display: grid;
    grid-template-columns: 1fr 1fr;
}

.mapContainer {
    padding: 10px;
    position: relative;
    display: flex;
    flex-direction: column;
    width: fit-content;
    align-self: center;
    justify-self: center;
}

.showMapBtn {
    position: absolute;
    align-self: center;
    background-color: #2f55a4;
    color: white;
    background-color: var(--primaryColor);
    color: var(--primaryTextColor);
    text-decoration: none;
    padding: 10px 12px;
    top: 20px;
    border-radius: 5px;
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease;

    &:hover, &:focus, &:active {
        transform: scale(1.1);
        box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.5);
    }
}

@media (max-width: 720px) {
    .map {
        width: 90vw;
        min-width: 320px;
    }
}
</style>